import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ForumHome from "../views/ForumHome";
import ForumThreadView from "../views/ForumThreadView";

export default function Forum(props) {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    await appContext.getAllThreads();
  }

  function getView() {
    if (
      appContext.navSubItem === "thread" &&
      appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <ForumThreadView uuid={appContext.navExtraItem} />;
    }

    return <ForumHome />;
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    init();
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const _view = getView();
    if (_view) {
      setView(_view);
    }
  }, [
    appContext.navSubItem,
    appContext.navExtraItem,
    appContext.navMoreItem,
    appContext.allThreads,
  ]);

  return view;
}
